import script from "./RadiogroupElement_blocks.vue?vue&type=script&lang=js"
export * from "./RadiogroupElement_blocks.vue?vue&type=script&lang=js"

import "./RadiogroupElement_blocks.vue?vue&type=style&index=0&id=6a6ae8fc&lang=scss"

const __exports__ = script;

export default __exports__